import {
    SURVEY_EDITOR_TEXT_ENTRY_CHANGE_QUESTION_AND_LABEL
} from "../../../../../constants";


export const onChangeTextEntryQuestionAndLabel = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: SURVEY_EDITOR_TEXT_ENTRY_CHANGE_QUESTION_AND_LABEL, payload });
    }
};